<template>
  <span>
    <div :key="gcFormKey" ref="gcFormContainer">
      <component
        :is="pageComponents.editClaim"
        :upload-host="urls.FILE_UPLOAD_URL"
        :claim-data="claimData"
        :template-id="$cgiSettings.templateId"
        :add-form="$cgiSettings.addForm"
        @submit="submitToPipeline"
        @getModels="getModels"
        @getVariants="getVariants"
        @getVehicleUid="getVehicleUid"
        @getVehicleYear="getVehicleYear"
      />
    </div>
  </span>
</template>
<script>
import urls from "../../urls";

const _ = require("lodash");

export default {
  name: "ReprocessClaimDetails",
  data() {
    return {
      gcFormKey: "",
      claimData: {
        vinSelection: null,
        makes: [],
        models: [],
        years: [],
        bodyTypes: [],
        variants: [],
        cityCategories: [],
        paintTypes: [],
        uid: "-",
        make: null,
        model: null,
        year: null,
        // body: null,
        bodyType: null,
        variant: null,
        state: null,
        vin: null,
        claim_number: null,
        cityCategory: null,
        paintType: null,
        claimDetails: {
          images: [],
          mileage: 0,
        },
      },
      urls,
      pageComponents: {
        editClaim: this.$cgiComponents.editClaim,
      },
    };
  },
  mounted() {
    // this.loadDefaults();
    this.getClaimDetails();
  },
  methods: {
    async loadDefaults() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      await Promise.all([this.getMakes(), this.getStates()]);
      this.gcFormKey = Math.random();
      loadingComponent.close();
    },
    async submitToPipeline(claimDetails) {
      const payload = JSON.parse(JSON.stringify(claimDetails));
      const response = await this.$http.post(
        `claims/${this.$route.params.claimUID}/edit-claim`,
        payload
      );
      window.localStorage.removeItem("currentClaim");
      if (response) {
        this.$router.push({
          name: "ClaimDetails",
          params: { claimUID: response.uid },
        });
      }
    },
    async getStates() {
      this.claimData.states = await this.$http.get("meta/states");
    },
    async getMakes() {
      // this.makes = await this.$http.get('meta/makes');
      this.claimData.allMake = await this.$http.get("/202103/vehicles/makes");
      this.claimData.allMake = _.sortBy(
        this.claimData.allMake,
        (item) => item.make
      );
      if (this.claimData.allMake && this.claimData.allMake.length > 0) {
        this.claimData.makes = this.claimData.allMake.map((x) => ({
          value: x.make,
        }));
      }
    },
    async getModels(make) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.allModel = await this.$http.get(
        `/202103/vehicles/models?make=${encodeURIComponent(make)}`
      );
      this.claimData.allModel = _.sortBy(
        this.claimData.allModel,
        (item) => item.model
      );
      this.claimData.models = [];
      this.claimData.allData = [];
      this.claimData.variants = [];
      this.claimData.years = [];
      this.claimData.bodyTypes = [];
      if (this.claimData.allModel && this.claimData.allModel.length > 0) {
        this.claimData.models = this.claimData.allModel.map((x) => ({
          value: x.model,
        }));
      }
      loadingComponent.close();
    },
    async getVariants(data) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.allData = [];
      this.claimData.variants = [];
      this.claimData.years = [];
      this.claimData.bodyTypes = [];
      this.claimData.allData = await this.$http.get(
        `/202103/vehicles/variants?make=${encodeURIComponent(
          data.make
        )}&model=${encodeURIComponent(data.model)}`
      );
      if (this.claimData.allData && this.claimData.allData.length > 0) {
        this.claimData.variants = _.reject(
          this.claimData.allData,
          (o) => o.variant === null
        ).map((x) => ({
          value: x.variant,
        }));
        // this.claimData.years = _.reject(this.claimData.allData, (o) => o.year === null).map((x) => ({
        //   value: Number(x.year),
        // }));
        this.claimData.bodyTypes = _.reject(
          this.claimData.allData,
          (o) => o.body === null
        ).map((x) => ({
          value: x.body,
        }));
      }
      this.claimData.variants = _.uniqBy(this.claimData.variants, "value");
      this.claimData.variants = _.sortBy(this.claimData.variants, ["value"]);
      this.claimData.years = _.uniqBy(this.claimData.years, "value");
      this.claimData.years = _.sortBy(this.claimData.years, ["value"]);
      this.claimData.bodyTypes = _.uniqBy(this.claimData.bodyTypes, "value");
      this.claimData.bodyTypes = _.sortBy(this.claimData.bodyTypes, ["value"]);
      if (this.claimData.bodyTypes.length === 1) {
        this.claimData.bodyType = this.claimData.bodyTypes[0].value;
        await this.getVehicleYear({
          make: data.make,
          model: data.model,
          bodyType: this.claimData.bodyType,
        });
      }
      loadingComponent.close();
    },
    async getCityCategories(vehicleUid) {
      // this.makes = await this.$http.get('meta/makes');
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.cityCategories = await this.$http.get(
        `/202103/city-categories/${vehicleUid}`
      );
      this.claimData.cityCategories = _.sortBy(
        this.claimData.cityCategories,
        (item) => item.city_category
      );
      if (
        this.claimData.cityCategories &&
        this.claimData.cityCategories.length > 0
      ) {
        this.claimData.cityCategories = this.claimData.cityCategories
          .filter((a) => a.city_category !== null)
          .map((x) => ({
            value: x.city_category,
          }));
      }
      loadingComponent.close();
    },
    async getPaintTypes(vehicleUid) {
      // this.makes = await this.$http.get('meta/makes');
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.paintTypes = await this.$http.get(
        `/202103/paint-types/${vehicleUid}`
      );
      this.claimData.paintTypes = _.sortBy(
        this.claimData.paintTypes,
        (item) => item.paint_type
      );
      if (this.claimData.paintTypes && this.claimData.paintTypes.length > 0) {
        this.claimData.paintTypes = this.claimData.paintTypes
          .filter((a) => a.paint_type !== null)
          .map((x) => ({
            value: x.paint_type,
          }));
      }
      loadingComponent.close();
    },
    async getVehicleUid(data) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      let uidData = null;
      if (
        data.make &&
        data.model &&
        data.year &&
        data.bodyType &&
        data.variant
      ) {
        uidData = this.claimData.allData.find(
          (x) =>
            x.make === data.make &&
            x.model === data.model &&
            x.year === data.year &&
            x.body === data.bodyType &&
            x.variant === data.variant
        );
      } else if (data.make && data.model && data.year && data.bodyType) {
        uidData = this.claimData.allData.find(
          (x) =>
            x.make === data.make &&
            x.model === data.model &&
            x.year === data.year &&
            x.body === data.bodyType &&
            x.variant === null
        );
      }

      if (uidData) {
        this.claimData.uid = uidData.vehicle_code;
        this.getPaintTypes(uidData.vehicle_code);
        this.getCityCategories(uidData.vehicle_code);
      }
      loadingComponent.close();
    },
    async getClaimDetails() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      if (this.$route.params.claimUID) {
        let localClaimDetails = window.localStorage.getItem("currentClaim");
        localClaimDetails = JSON.parse(localClaimDetails);
        if (
          localClaimDetails &&
          String(localClaimDetails.claimUID) ===
            String(this.$route.params.claimUID)
        ) {
          this.currentClaim = localClaimDetails;
        } else {
          // below api is for US region only

          if (window.localStorage.getItem("region") === "US") {
            let url = `/202103/claims/${this.$route.params.claimUID}?claimMeta=true`;
            if (
              this.claimVersions &&
              this.claimVersions.selectedClaimId &&
              this.claimVersions.selectedClaimId !== null
            ) {
              url = `/202103/claims/${this.$route.params.claimUID}?claimMeta=true&claimId=${this.claimVersions.selectedClaimId}`;
            }
            // // condition to check the simplified UI show/hide feature
            // if (this.showSimplifiedUI) {
            //   url += "&isSimplifiedSummary=true";
            // }
            // if (this.getEstimateData) {
            //   url += `&templateId=${this.getEstimateData}`;
            // }
            // if (this.isUPDEnabled) {
            //   url += "&isUPDEnabled=true";
            // }
            this.currentClaim = await this.$http.get(url);
          } else {
            const url = `/202103/claims/${this.$route.params.claimUID}?claimMeta=true&transformResponse=true`;
            this.currentClaim = await this.$http.get(url);
          }
        }

        this.loaderText =
          this.currentClaim && this.currentClaim.message
            ? this.currentClaim.message
            : "Processing Claim Request";
        this.claimData.make = this.currentClaim.make;
        this.claimData.model = this.currentClaim.model;
        this.claimData.year = this.currentClaim.year;
        this.claimData.mileage = this.currentClaim.mileage;
        this.claimData.uid = this.currentClaim.vehicle_code;
        this.claimData.compulsory_excess =
          this.currentClaim.compulsory_excess || 0;
        const metaData = await this.$http.get(
          `/202103/vehicles/allMeta?vehicleCode=${this.currentClaim.vehicle_code}`
        );
        this.claimData.makes = metaData.makes;
        if (this.claimData.makes && this.claimData.makes.length > 0) {
          this.claimData.makes = this.claimData.makes.map((x) => ({
            value: x.make,
          }));
          this.claimData.makes = _.sortBy(
            this.claimData.makes,
            (item) => item.value
          );
        }
        this.claimData.models = metaData.models;
        if (this.claimData.models && this.claimData.models.length > 0) {
          this.claimData.models = this.claimData.models.map((x) => ({
            value: x.model,
          }));
          this.claimData.allModel = _.sortBy(
            this.claimData.models,
            (item) => item.value
          );
        }
        this.claimData.states = [];
        this.claimData.years = [];
        this.claimData.bodyTypes = [];
        this.claimData.variants = [];
        this.claimData.allData = metaData.variants;
        if (this.claimData.allData && this.claimData.allData.length > 0) {
          this.claimData.variants = _.reject(
            this.claimData.allData,
            (o) => o.variant === null
          ).map((x) => ({
            value: x.variant,
          }));
          this.claimData.years = _.reject(
            metaData.variants,
            (o) => o.year === null
          ).map((x) => ({
            value: Number(x.year),
          }));
          this.claimData.bodyTypes = _.reject(
            metaData.variants,
            (o) => o.body === null
          ).map((x) => ({
            value: x.body,
          }));
          this.claimData.variants = _.uniqBy(this.claimData.variants, "value");
          this.claimData.variants = _.sortBy(this.claimData.variants, [
            "value",
          ]);
          this.claimData.years = _.uniqBy(this.claimData.years, "value");
          this.claimData.years = _.reverse(
            _.sortBy(this.claimData.years, (item) => item.value)
          ); // _.sortBy(this.claimData.years, ['value']);
          this.claimData.bodyTypes = _.uniqBy(
            this.claimData.bodyTypes,
            "value"
          );
          this.claimData.bodyTypes = _.sortBy(this.claimData.bodyTypes, [
            "value",
          ]);
        }
        this.claimData.cityCategories = metaData.cityCategory;
        if (
          this.claimData.cityCategories &&
          this.claimData.cityCategories.length > 0
        ) {
          this.claimData.cityCategories = this.claimData.cityCategories
            .filter((a) => a.city_category !== null)
            .map((x) => ({
              value: x.city_category,
            }));
          this.claimData.cityCategories = _.sortBy(
            this.claimData.cityCategories,
            (item) => item.value
          );
        }
        this.claimData.paintTypes = metaData.paintTypes;
        if (this.claimData.paintTypes && this.claimData.paintTypes.length > 0) {
          this.claimData.paintTypes = this.claimData.paintTypes
            .filter((a) => a.paint_type !== null)
            .map((x) => ({
              value: x.paint_type,
            }));
          this.claimData.paintTypes = _.sortBy(
            this.claimData.paintTypes,
            (item) => item.value
          );
        }
      }
      this.claimData.bodyType = this.currentClaim.body_type.toUpperCase();
      this.claimData.variant = this.currentClaim.variant;
      this.claimData.state = this.currentClaim.state;
      this.claimData.claim_number = this.currentClaim.claim_number;
      this.claimData.vin = this.currentClaim.vin;
      this.claimData.cityCategory = this.currentClaim.city_category;
      this.claimData.paintType = this.currentClaim.paint_type;
      this.claimData.claimDetails.mileage = this.currentClaim.mileage;
      this.gcFormKey = Math.random();
      loadingComponent.close();
    },
    async getVehicleYear(data) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.years = [];
      let filteredData = [];
      if (data.make && data.model && data.bodyType && data.variant) {
        filteredData = this.claimData.allData.filter(
          (x) =>
            x.make === data.make &&
            x.model === data.model &&
            x.body === data.bodyType &&
            x.variant === data.variant
        );
      } else if (data.make && data.model && data.bodyType) {
        filteredData = this.claimData.allData.filter(
          (x) =>
            x.make === data.make &&
            x.model === data.model &&
            x.body === data.bodyType &&
            x.variant === null
        );
      }
      if (filteredData && filteredData.length > 0) {
        this.claimData.years = _.reject(
          filteredData,
          (o) => o.year === null
        ).map((x) => ({
          value: Number(x.year),
        }));
        this.claimData.years = _.uniqBy(this.claimData.years, "value");
        this.claimData.years = _.reverse(
          _.sortBy(this.claimData.years, (item) => item.value)
        );
      }
      loadingComponent.close();
    },
  },
};
</script>
